import { useContext, useEffect, useState } from "react";
import { Button, Typography, Col, Skeleton, List } from "antd";
import { useProjectInfo } from "./hook";
import { useFacebookPixel } from "shared-components/GlobalHooks/web/FacebookPixel.hook";
import { useRouter } from "next/router";
import { useUser } from "shared-components/Components/User/User.hook";
import {
	getInitCountryCode
} from "shared-components/Components/Property/InformationRequest/LeadButtons/PhoneButton/web";
import { CountryCode, getCountryCallingCode } from "libphonenumber-js";
import cookie from "js-cookie";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useContactModal } from "shared-components/Contexts/ContactModal/context";
import { getBaseDomain as loginBasePath } from "@Utils/Functions";
import { getInitialContactForm } from "src/utils/Functions";

const ProjectInfo = ({ loading = false, projectId, ...rest }) => {
	const { query } = useRouter();
	const { country_code } = useContext(ConfigStateContext);
	const {
		projectInfoList,
		sendLead,
		formCompleted,
		dataRegisterMutation
	} = useProjectInfo(projectId, rest, query);

	const [asked, setAsked] = useState([]);
	// const { loginBasePath } = getConfig().publicRuntimeConfig;
	const FP = useFacebookPixel();
	const {
		isLoggedIn,
		user: { refetch, data: dataUser },
	} = useUser();
	const { openContactModal, closeContactModal } = useContactModal();
	const [fieldState, setFieldState] = useState("");
	const [selectedCountryCode, setSelectedCountryCode] = useState({
		code: "",
		value: "",
	});

	useEffect(() => {
		if (formCompleted) {
			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	useEffect(() => {
		setSelectedCountryCode(getInitCountryCode());
	}, []);

	useEffect(() => {
		if (country_code) {
			setSelectedCountryCode({
				code: country_code as CountryCode,
				value: `+${getCountryCallingCode(country_code as CountryCode)}`,
			})
		}
	}, [country_code]);

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, {
			expires: 365,
			domain: loginBasePath(),
			path: "/",
		});
		localStorage.setItem("user_md5", data.user_md5);
		refetch();
	};

	const handleClick = async (e: MouseEvent, fieldState: string) => {
		e.preventDefault();
		e.stopPropagation();
		const dataModal = getInitialContactForm(isLoggedIn, dataUser);

		let res = await sendLead(fieldState, {
			name: dataModal.name,
			phone: selectedCountryCode.value + dataModal.phone,
			email: dataModal.email,
		});

		if (res) {
			setAsked([...asked, fieldState]);
			closeContactModal();
		}
	};

	const askFastAction = field => {
		const currentField = typeof field === "string" ? field : fieldState;

		sendLead(currentField)
			.then(res => {
				if (res) {
					setAsked([...asked, field]);
					handleClickShowNotification({
						message: "¡Consulta express enviada con éxito!",
					});
				}
			})
			.catch(error => {
				console.log(error);
			})
	};

	const handleClickShowNotification = async ({
		type = "success",
		message = "",
		description = "",
	}) => {
		const { showNotification } = await import(
			"shared-components/Components/CustomNotification/web"
		);
		showNotification(type, message, description);
	};

	const SpanAskFast = ({ field }) => {
		if (asked.some(o => o == field)) {
			return <Typography.Text disabled>{"¡Preguntado!"}</Typography.Text>;
		} else {
			return (
				<Button
					type="text"
					ghost={true}
					onClick={() => {
						if (!isLoggedIn) {
							setFieldState(field);

							openContactModal({
								id: projectId,
								owner: null,
								isProject: true,
								projectId: null,
								defaultMessage: "",
								source: "propertyDetail",
								isExpress: true,
								expressCallback: (e) => handleClick(e, field),
								ctaToShow: {
									contact: true,
									phone: false,
									whatsapp: false
								}
							})
						} else {
							askFastAction(field);
						}
					}}
					className="btnQuestion"
				>
					{"¡Pregúntale!"}
				</Button>
			);
		}
	};

	const ProjectInfoItem = ({ text, value, field, key, show }) => {
		if (!show) return null;
		return (
			<List.Item>
				<Col span={12}>
					<b>{text}</b>
				</Col>
				<Col span={12}>
					{value
						? (typeof value === 'object' ? value.text : value)
						: <SpanAskFast field={field ?? key} />}
				</Col>
			</List.Item>
		);
	};

	if (loading) {
		return <Skeleton active />;
	}

	if (!projectInfoList.length) {
		return null;
	}

	return (
		<>
			<List
				size="small"
				bordered
				className="project-info"
				dataSource={projectInfoList}
				renderItem={ProjectInfoItem}
			/>
		</>
	);
};

export { ProjectInfo };

